<template>
  <div v-if="load < 2">
    <LoaderCar width="600px" marginTop="0"/>
  </div>
  <div v-else class="background">
    <Header :eleves="eleves" ref="headRefHeader" :moniteurs="moniteurs" :heuresDispoSemaineType="heuresDispoSemaineType" @loadEleve="testCallEmit" @setupDispo="setupDispo" @changeDisplayApointment="changeDisplayApointment" @getEleves="getEleves" @cancelEleveChoix = "cancelEleveChoix" @selectMoniteurSemaineType="setMoniteurSemaineType"/>
    <div class="calendar" v-if="$store.state.planningSelectChoice === 'SEMAINE TYPE'">
        <WeekTypeCalendar :moniteur="moniteurSemaineType" @heuresDispoChange="setHeuresDispoSemaineType"/>
    </div>
    <div class="calendar" v-else>
        <Calendar :eleves="eleves" @selectItemHeader="selectItemHeader" @refreshEleveHeader="refreshEleveHeader" :countEleves="countEleves" :moniteurs="moniteurs" ref="headRef" @getEleves="getEleves" @getMoniteurs="getMoniteurs" @getMoniteursChange="getMoniteursChangePlage"/>
    </div>
    
  </div>
  
</template>

<script>
import Calendar from "@/components/agence/planning/Calendar.vue";
import Header from "@/components/agence/planning/Header.vue";
import WeekTypeCalendar from "@/components/agence/planning/WeekTypeCalendar.vue";
import LoaderCar from "@/components/LoaderCar.vue";
import { ref } from 'vue'


export default {

  setup(){
    const headRef = ref();
    const headRefHeader = ref();
    const setupDispo = (test) => headRef.value && headRef.value.displayDispo(test);
    const changeDisplayApointment = (display) => headRef.value && headRef.value.changeDisplayApointment(display);
    const cancelEleveChoix = () => headRef.value && headRef.value.cancelEleveChoix();
    const putOnPlanningApointment = () => headRef.value && headRef.value.putOnPlanningApointment();
    const selectItemHeader = (e) => headRefHeader.value.selectItem(e);
    const refreshEleveHeader = (eleveId) => headRefHeader.value && headRefHeader.value.refreshSelectedEleve(eleveId);

    return{
      headRef,
      setupDispo,
      changeDisplayApointment,
      cancelEleveChoix,
      putOnPlanningApointment,
      headRefHeader,
      selectItemHeader,
      refreshEleveHeader
    }
  },

  components: {
    Calendar,
    Header,
    WeekTypeCalendar,
    LoaderCar
  },

  mounted() {
    this.getEleves();
    this.getMoniteurs();
  },

  data() {
    return {
      eleves : [],
      load : 0,
      moniteurs: [],
      countEleves : 0,
      moniteurSemaineType: null,
      heuresDispoSemaineType: null,
    }
  },
  methods: {

    setMoniteurSemaineType(moniteur){
      this.moniteurSemaineType = moniteur;
    },

    setHeuresDispoSemaineType(heures){
      this.heuresDispoSemaineType = heures;
    },

    testCallEmit(){
      console.log("premier console")
      
      
      //this.Calendar.testCs();
    },

    getEleves(){
      window.api.get("/eleves/agence/planning/" + this.$store.state.user.agence.id +"/offset/0", {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.eleves = response.data.eleves;
          this.countEleves = response.data.count;
          this.load++;
        }).catch(error => {
          console.log(error)
        })
    },

    getMoniteurs(){
      window.api.get("/moniteurs/agence/planning/" + this.$store.state.user.agence.id + "/" + this.$store.state.user.id, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.moniteurs = response.data.moniteurs;
          this.$store.commit("setMoniteursPlanningAgence", this.moniteurs);
          this.$store.commit("setMoniteursPlanningAgenceArchive", response.data.unMoniteurs);
          this.$store.commit("setLieuxMonosPlanning", response.data.lieux);
          this.$store.commit("setGroupeLieuPlanning", response.data.groupe);
          this.load++;
        }).catch(error => {
          console.log(error)
        })
    },

    getMoniteursChangePlage(date, planningForm){
      window.api.post("/moniteurs/agence/planning/" + this.$store.state.user.agence.id + "/" + this.$store.state.user.id+"/changeplan", 
        {
          date : date,
          planningForm: planningForm
        },
        {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.moniteurs = response.data.moniteurs;
          this.$store.commit("setMoniteursPlanningAgence", this.moniteurs);
          this.$store.commit("setMoniteursPlanningAgenceArchive", response.data.unMoniteurs);
          this.$store.commit("setLieuxMonosPlanning", response.data.lieux);
          this.$store.commit("setGroupeLieuPlanning", response.data.groupe);
          this.load++;
          this.putOnPlanningApointment();
        }).catch(error => {
          console.log(error)
        })
    }

  },
};
</script>

<style scoped>
div.background {
  background: #f4f6f9;
  min-height: 100vh;

}

div.calendar{
    width: 99%;
    margin: auto;
    margin-bottom: 10px;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

@media (max-width: 640px) {
  div.background {
    overflow-x: hidden;
  }

  div.calendar {
    width: 100%;
    margin: 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}
</style>
